module.exports = __webpack_public_path__ + "img/slide11-piece-23.fe898f4a.png";